const SIG_BALANCE = 'balanceOf(address)';
const SIG_ALLOWANCE = 'allowance(address,address)';
const SIG_APPROVE = 'approve(address,uint256)';
const SIG_DEPOSIT_FOR = 'depositFor(address,uint256)';
const SIG_WITHDRAW_TO = 'withdrawTo(address,uint256)';

export {
  SIG_BALANCE,
  SIG_ALLOWANCE,
  SIG_APPROVE,
  SIG_DEPOSIT_FOR,
  SIG_WITHDRAW_TO
};
